import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ButtonSelect, ButtonTextSelectControl } from '../../../Select'

import { getIntegrationsFilterOption } from './IntegrationsFilterSelect.utils'

import * as styles from './IntegrationsFilterSelect.module.css'

function IntegrationsFilterSelect({ options, qaName, value, onSelect }) {
  const selectedOption = getIntegrationsFilterOption({ options, value })

  function handleSelectItem(option) {
    onSelect(option.value)
  }

  return (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      className={styles.IntegrationsFilterSelect}
      controlProps={{
        buttonProps: {
          Button: Button.Outlined,
          height: BUTTON_HEIGHT_32,
          text: selectedOption.label,
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomStart,
        maxWidthByRef: false,
      }}
      dropdownProps={{ className: styles.dropdown }}
      filter={null}
      listProps={{ headerProps: { Search: null } }}
      options={options}
      qaName={qaName}
      value={selectedOption}
      onSelectItem={handleSelectItem}
    />
  )
}

export default IntegrationsFilterSelect
